import { namespace } from 'vuex-class';
import { ICreateEditorState } from './create-editor.types';

export const CreateEditor = namespace('contentLibrary/createResource/createEditor');

export const state: ICreateEditorState = {
  createdEditorId: null,
};

export enum ECreateEditorAction {
  Create = 'create',
  CreateSuccess = 'createSuccess',
  CreateFailed = 'createFailed',
  Reset = 'reset',
}

export enum ECreateEditorMutation {
  SetCreatedEditorId = 'setCreatedEditorId',
  SetState = 'setState',
}
